var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutline1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 61,
    viewBox: "0 0 84 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.3125,
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9 29.7809L38.6777 38.0032C36.0123 40.6686 31.6866 40.6686 29.0174 38.0032L28.1402 37.126C25.4748 34.4605 25.4748 30.1348 28.1402 27.4656L41.6105 13.9991C44.2759 11.3336 48.6016 11.3336 51.2708 13.9991L52.148 14.8763C54.4182 17.1464 54.757 20.6138 53.1645 23.2416",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8752 20.7343L45.4128 31.2718",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1102 17.0372C47.4726 15.3995 44.8146 15.3995 43.177 17.0372L42.3901 17.824",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2552 32.5743C54.1131 34.7164 50.6457 34.7164 48.5036 32.5743C46.3614 30.4322 46.3614 26.9648 48.5036 24.8227C50.6457 22.6805 54.1131 22.6805 56.2552 24.8227C58.3974 26.9648 58.3974 30.4322 56.2552 32.5743Z",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8999 28.6966H57.8629",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.312 43.2587C52.7992 40.2708 50.7719 37.4538 47.784 36.9666C44.7961 36.4795 41.9791 38.5067 41.4919 41.4946C41.0048 44.4825 43.032 47.2996 46.0199 47.7867C49.0078 48.2739 51.8249 46.2466 52.312 43.2587Z",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.022 38.5001L50.7736 46.2517",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutline1);
export default __webpack_public_path__ + "static/media/Outline(1).11ac270a5bd1de3868f42d0ffdeeca9f.svg";
export { ForwardRef as ReactComponent };